import {
    GET_BRS_LIST,
    GET_BRS_DETAILS,
    CREATE_BRS,
    UPDATE_BRS,
    FINALIZE_BRS,
    DELETE_BRS,
    CLEAR_BRS_ENTRIES,
    IMPORT_BRS_STATEMENT,
    AUTO_MATCH_BRS,
    MANUAL_MATCH_BRS,
    UNMATCH_BRS,
    CLEAR_BRS_STATE,
} from '../../index.types';

export const getBRSList = (data) => ({ type: GET_BRS_LIST, data });
export const getBRSDetails = (data) => ({ type: GET_BRS_DETAILS, data });
export const createBRS = (data) => ({ type: CREATE_BRS, data });
export const updateBRS = (data) => ({ type: UPDATE_BRS, data });
export const finalizeBRS = (data) => ({ type: FINALIZE_BRS, data });
export const deleteBRS = (data) => ({ type: DELETE_BRS, data });
export const clearBRSEntries = (data) => ({ type: CLEAR_BRS_ENTRIES, data });
export const importBRSStatement = (data) => ({ type: IMPORT_BRS_STATEMENT, data });
export const autoMatchBRS = (data) => ({ type: AUTO_MATCH_BRS, data });
export const manualMatchBRS = (data) => ({ type: MANUAL_MATCH_BRS, data });
export const unmatchBRS = (data) => ({ type: UNMATCH_BRS, data });
export const clearBRSState = () => ({ type: CLEAR_BRS_STATE });
